module.exports = "<p>\r\n  awsop-lab8 works!\r\n</p>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/course/labs/awsop/awsop-lab8/awsop-lab8.component.html
// module id = ./src/app/course/labs/awsop/awsop-lab8/awsop-lab8.component.html
// module chunks = main